import { getConfiguration } from './configuration';

/**
 * Get capabilities from the configuration.
 * Mirrors portal/src/lib/capabilities.js and react_dashboard's equivalent —
 * ticketing_enabled is a base Limits flag (overridable per-vertical by
 * feature_ticketing, merged server-side), so it defaults to disabled when
 * absent or unreachable, unlike the `!== false` default-enabled convention
 * used for vertical-only feature_* flags.
 */
export const getCapabilities = async () => {
    try {
        const config = await getConfiguration();
        const capabilities = config?.capabilities || {};
        return {
            ticketing_enabled: capabilities.ticketing_enabled || false,
        };
    } catch (error) {
        console.error('Failed to load capabilities:', error);
        return { ticketing_enabled: false };
    }
};

export const isTicketingEnabled = async () => {
    const capabilities = await getCapabilities();
    return capabilities.ticketing_enabled;
};
